export default __webpack_public_path__ + "static/exp4-401e2168398d750e9b6d54508c94b527.png";